import PropTypes from 'prop-types';
import { memo } from 'react';

import { useConfig } from '../../../context/config-provider';
import { useMdxComponent } from '../../../hooks/use-mdx-component';
import { getCurrentYear } from '../../../utils/date';
import { FormattedText } from '../../formatted-text/formatted-text';
import { FooterLicense } from '../footer-license/footer-license';

import './footer-copyright.scss';

export function FooterCopyrightUI({ isWithLicense }) {
  const { footer } = useConfig();
  const disclaimer = useMdxComponent(footer?.disclaimer, { year: () => getCurrentYear() });

  return (
    <div className="sb-FooterCopyright">
      {isWithLicense && <FooterLicense className="sb-FooterCopyright-seal" />}

      <div className="sb-FooterCopyright-text">
        {footer?.copyright && (
          <span className="sb-FooterCopyright-title">
            <FormattedText text={footer.copyright} values={{ year: getCurrentYear() }} />
          </span>
        )}

        <div className="sb-FooterCopyright-subtitle">{disclaimer}</div>
      </div>
    </div>
  );
}

FooterCopyrightUI.propTypes = {
  isWithLicense: PropTypes.bool,
};

FooterCopyrightUI.defaultProps = {
  isWithLicense: true,
};

export const FooterCopyright = memo(FooterCopyrightUI);
